import React from "react";
import CachedIcon from '@mui/icons-material/Cached';


export default function DateRangePicker({setStart,start,setEnd,end}) {
  const toYMD = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  const todayStr = toYMD(new Date());
  
  const handlReset =()=>{
    setStart('')
    setEnd('')
  }

 

  return (
    <div style={styles.container}>
      <div style={styles.field}>
        <label htmlFor="startDate" style={styles.label}>
          ⏳ Start Date
        </label>
        <input
          id="startDate"
          type="date"
          value={start}
          max={todayStr}
          style={styles.input}
          
          onChange={(e) => {
            setStart(e.target.value);
            if (end && e.target.value > end) {
              setEnd(todayStr);
            }
          }}
        />
      </div>

      <div style={styles.field}>
        <label htmlFor="endDate" style={styles.label}>
          🏁 End Date
        </label>
        <input
          id="endDate"
          type="date"
          value={end}
          min={start || undefined}
          max={todayStr}
          disabled={start ? false : true}
          style={{
            ...styles.input,
            cursor :start ? "pointer" : "not-allowed",
          }}
          onChange={(e) => setEnd(e.target.value)}
        />
      </div>
      <div 
       style={{
        fontSize :"20px", 
        cursor:"pointer"
       }} 
       onClick={handlReset}
       >
        <CachedIcon/>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    gap: "24px",
    padding: "20px",
    border: "1px solid #ddd",
    borderRadius: "12px",
    background: "#f9fafb",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    maxWidth: "500px",
    // margin: "20px auto",
    justifyContent: "space-between",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  label: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#374151",
    marginBottom: "6px",
  },
  input: {
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    fontSize: "14px",
    outline: "none",
    transition: "border-color 0.2s",
    cursor:"pointer"
  },
};
